import React from 'react'
import { Navigate } from 'react-router'
import AudioElement from '../AudioElement/AudioElement'
import "../../Pages/ContestPage.css";
function  Hotel({ contestDetails, isPlaying, setIsplaying, audioElem, campaignClosed }) {
  // console.log(contestDetails);
  var cardgrad = {
    background: `linear-gradient(141.7deg, ${contestDetails?.buttonColor} 0%, rgba(38, 38, 38, 0) 35.04%, rgba(38, 38, 38, 0) 35.04%), #171717`,
    // background: `linear-gradient(121.7deg, ${contestDetails?.buttonColor} 0%, rgba(38, 38, 38, 0) 35.04%), #171717`,
  };
  return (
    <>
      {/* <div className='pt-[80p] '>
        {contestDetails?.contestPoster &&
          <img src={contestDetails?.contestPoster} alt="" className={`fixedImg h-[27vw] min-h-[167px] max-h-[290px] w-[100%] object-cover fixedMeBck`} style={{ objectPosition: "0% 30%" }} />
        }
      </div> */}
      <div className="px-[16px] borderRound  z-10  flex flex-col">
        {/* <span className=" text-[23px] text-center font-semibold" style={{color:contestDetails?.buttonColor}}>
          {contestDetails?.contestName}
        </span> */}
        {/* <span style={{ color: contestDetails?.buttonColor }} className=" text-[17px] md:text-[20px]">
          {contestDetails?.contestName}
        </span> */}
      </div>
      {/* <div className='px-[16px]'>
        {!campaignClosed && <div
          className={`w-[100%] h-[auto] rounded-[20px] p-[16px] mt-[30px] `}
          style={cardgrad}
        >
          <p className="five text-[21px]">
            {contestDetails?.entryFee?.heading}
          </p>
          <p className="four text-[14px] text-[#B7B7B7] mt-[15px]">
            {contestDetails?.entryFee.fee}
          </p>
          <p className="four text-[14px] text-[#B7B7B7] mt-[15px]">
            {contestDetails?.entryFee.description}
          </p>
          {'prizeImage' in contestDetails?.entryFee &&
            <img src={contestDetails?.entryFee.prizeImage} alt="" />
          }
        </div>}
      </div> */}
    </>
  )
}

export default Hotel